import { compose } from 'recompose';
import { addProps } from 'utils/recompose';
import unavailableProgressCircle from './images/progress-indicator-small-na.svg';
import bmwSeriesCompleteLarge from './images/bmw-series-complete-large.svg';
import bmwSeriesCompleteSideNav from './images/bmw-side-nav-series-complete.svg';
import dashedLine from './images/dashed-line.svg';

export const staticProgressIcon = ({ totalQuota, submitted, sideNav }) => {
  if (totalQuota === 0) {
    if (sideNav) {
      return dashedLine;
    } else {
      return unavailableProgressCircle;
    }
    // TODO when data syncing is up we can use unsubmitted === 0 if that will be a more accurate number
  } else if (submitted >= totalQuota) {
    if (sideNav) {
      return bmwSeriesCompleteSideNav;
    } else {
      return bmwSeriesCompleteLarge;
    }
  }
  return false;
};

export default compose(
  addProps({
    staticProgressIcon,
  }),
);
